var React = require('react');
var ReactNative = require('react-native');
var NativeAppEventEmitter = require('./wrappers/NativeAppEventEmitter-wrapper');

const Icon = require('./wrappers/ReUpIcon');

var ReUpScrollView = require('./ReUpScrollView.js');
var ShadowView = require('./ShadowView.js');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpField = require('./ReUpField');

var ReUpButton = require('./ReUpButton.js');
var ReUpText = require('./ReUpText');
var ProgressOverlay = require('./ProgressOverlay.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  Platform,
  Animated,
  StyleSheet,
  Keyboard,
} = ReactNative;

var PhoneNumberVerify = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    return {
      isInputtingPhone:true,
      hasValidPhone:false,
      hasValidCode:false,
      isInError:false,
    };
  },

  _phoneText1Placeholder : "###",
  _phoneText2Placeholder : "###",
  _phoneText3Placeholder : "####",
  componentDidMount : function()
  {
    var appManager = this.props.appManager;
    if( appManager.isLoggedIn() )
    {
      var phoneNumber = appManager.currentUser()[ModelConstants.PhoneNumber];
      if( typeof phoneNumber !== 'undefined' && phoneNumber != null )
      {
        this._phoneText1Placeholder = phoneNumber.substring(1,4);
        this._phoneText2Placeholder = phoneNumber.substring(4,7);
        this._phoneText3Placeholder = phoneNumber.substring(7,11);
      }
    }

    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
    if( !useInterstitialFlow )
    {
      var thisThing = this;
      setTimeout(()=>
      {
        if( thisThing._phone1 ) thisThing._phone1.focus()
      }, 1000);
    }
    this.setIsInError(false);
  },

  componentWillUnmount : function()
  {
  },

  didUpdate : function()
  {

  },

  focus: function()
  {
    var thisThing = this;
    setTimeout(()=>
    {
      if( thisThing._phone1 ) thisThing._phone1.focus()
    }, 200)
  },

  _phoneTextCountryCode : "1",
  _phoneText1 : "",
  _phoneText2 : "",
  _phoneText3 : "",
  hasValidPhone : function()
  {
    return this._phoneText1.length == 3 && this._phoneText2.length == 3 && this._phoneText3.length == 4;
  },

  _codeText1 : "",
  _codeText2 : "",
  _codeText3 : "",
  _codeText4 : "",
  _codeText5 : "",
  _codeText6 : "",
  hasValidCode : function()
  {
    return this._codeText1.length == 1 && this._codeText2.length == 1 && this._codeText3.length == 1 && this._codeText4.length == 1 && this._codeText5.length == 1 && this._codeText6.length == 1;
  },

  getPhoneNumber : function()
  {
    return this._phoneTextCountryCode
      + "-" + this._phoneText1
      + "-" + this._phoneText2
      + "-" + this._phoneText3;
  },

  getPhoneNumberPlain : function()
  {
    return this._phoneTextCountryCode
      + this._phoneText1
      + this._phoneText2
      + this._phoneText3;
  },

  getCode : function()
  {
    return this._codeText1
      + this._codeText2
      + this._codeText3
      + this._codeText4
      + this._codeText5
      + this._codeText6;
  },

  _hasAutoCheckedCode : false,
  checkCode : function()
  {
    this._hasAutoCheckedCode = true;

    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
    this.setSpinnerShown(true);
    NetworkManager.verifyAndSetPhoneNumber(appManager, thisThing.getPhoneNumber(), thisThing.getCode(), (data)=>
    {
      thisThing.setSpinnerShown(false);
      var user = appManager.currentUser();
      user[ModelConstants.PhoneNumber] = thisThing.getPhoneNumberPlain();
      appManager.setCurrentUser(user);
      if( useInterstitialFlow )
      {
        thisThing.props.extras.setPhoneDidFinish();
      }
      else
      {
        var phoneSuccessTitle = locManager.localizedStringForKey("PHONE_SUCCESS_ALERT_TITLE", "Success!");
        var phoneSuccessBody = locManager.localizedStringForKey("PHONE_SUCCESS_ALERT_BODY", "Your phone number has been set.");
        var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
        appActions.showAlert(phoneSuccessTitle,phoneSuccessBody,[successOkay],[function()
        {
          appActions.hideAlert();
          appActions.requestPop(true);
        }], function()
        {
          appActions.requestPop(true);
        })
      }
    }, ()=>
    {
      thisThing.setSpinnerShown(false);
      thisThing.setIsInError(true, locManager.localizedStringForKey("INVALID_CODE", "Invalid code."));
    }, ()=>
    {
      thisThing.setSpinnerShown(false);
      if( useInterstitialFlow )
      {
        thisThing.props.extras.showNetworkErrorAlert();
      }
      else
      {
        thisThing.setIsInError(false);
      }
    })
  },

  setSpinnerShown : function(shouldShowSpinner)
  {
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
    if( useInterstitialFlow )
    {
      this.setState({shouldShowSpinner});
    }
    else
    {
      this.props.appActions.setSpinnerShown(shouldShowSpinner);
    }
  },

  sendCode : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    this.setSpinnerShown(true);
    NetworkManager.sendPhoneNumberCode(appManager, thisThing.getPhoneNumber(), ()=>
    {
      thisThing.setSpinnerShown(false);
      thisThing.setState({isInputtingPhone:false});
      setTimeout(()=>
      {
        if( thisThing._code1 ) thisThing._code1.focus()
        thisThing.setIsInError(false);;
      }, 200)
    }, (error)=>
    {
      thisThing.setSpinnerShown(false);
      if( typeof error !== 'undefined' && error.code == -69 )
      {
        thisThing.setIsInError(true, locManager.localizedStringForKey("DUPLICATE_PHONE_ERROR", "This phone number is already in use."));
      }
      else
      {
        thisThing.setIsInError(true, locManager.localizedStringForKey("INVALID_PHONE_ERROR", "This phone number is invalid."));
      }
      thisThing.setState({isInputtingPhone:true});
    }, ()=>
    {
      thisThing.setSpinnerShown(false);
      thisThing.setState({isInputtingPhone:true});
    })
  },

  setIsInError: function(isInError, errorMessage)
  {
    if( isInError != this.state.isInError ) this.setState({isInError});
    if( typeof errorMessage !== 'undefined' && errorMessage != this.state.errorMessage )
    {
      this.setState({errorMessage})
    }
    else if( typeof errorMessage === 'undefined' && this.state.errorMessage != null )
    {
      this.setState({errorMessage:null})
    }
  },

  backSpacePressed : function(fieldKey)
  {
    switch (fieldKey) {
      case 'code1':
        break;
      case 'code2':
        if( this._codeText2.length <= 0 )
        {
          this._codeText1 = "";
          this._code1.setText("");
          this._code1.focus();
        }
        break;
      case 'code3':
        if( this._codeText3.length <= 0 )
        {
          this._codeText2 = "";
          this._code2.setText("");
          this._code2.focus();
        }
        break;
      case 'code4':
        if( this._codeText4.length <= 0 )
        {
          this._codeText3 = "";
          this._code3.setText("");
          this._code3.focus();
        }
        break;
      case 'code5':
        if( this._codeText5.length <= 0 )
        {
          this._codeText4 = "";
          this._code4.setText("");
          this._code4.focus();
        }
        break;
      case 'code6':
        if( this._codeText6.length <= 0 )
        {
          this._codeText5 = "";
          this._code5.setText("");
          this._code5.focus();
        }
        break;
      case 'phone1':
        break;
      case 'phone2':
        if( this._phoneText2.length <= 0 )
        {
          this._phoneText1 = "";
          this._phone1.setText("");
          this._phone1.focus();
        }
        break;
      case 'phone3':
        if( this._phoneText3.length <= 0 )
        {
          this._phoneText2 = "";
          this._phone2.setText("");
          this._phone2.focus();
        }
        break;
      default:

    }
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var isInputtingPhone = this.state.isInputtingPhone;
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    var phoneSeparators = ["(",") "," - "];

    var instructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS", "Please verify your phone number below.");
    if( useInterstitialFlow )
    {
      instructions = locManager.localizedStringForKey("PAYMENTTYPES_PHONE_INSTRUCTIONS", "You must verify your phone number before you can reload your app.")
    }
    else if( appActions._attemptedFeature != null && appActions._attemptedFeature.length > 0 )
    {
      for( var i = 0; i < appActions._attemptedFeature.length; i++ )
      {
        var firstAttemptedFeature = appActions._attemptedFeature[i];
        if( firstAttemptedFeature.key == "PaymentTypes" ) instructions = locManager.localizedStringForKey("PAYMENTTYPES_PHONE_INSTRUCTIONS", "You must verify your phone number before you can add a payment type.");
        if( firstAttemptedFeature.key == "AddCredit" ) instructions = locManager.localizedStringForKey("ADDCREDIT_PHONE_INSTRUCTIONS", "You must verify your phone number before you can reload your app.");
        if( firstAttemptedFeature.key == "UseReward" ) instructions = locManager.localizedStringForKey("USEREWARD_PHONE_INSTRUCTIONS", "You must verify your phone number before you can redeem a reward.");
        if( firstAttemptedFeature.key == "SendGiftCard" ) instructions = locManager.localizedStringForKey("SENDGIFTCARD_PHONE_INSTRUCTIONS", "You must verify your phone number before you can purchase a gift card.");
        if( firstAttemptedFeature.key == "AddPass" ) instructions = locManager.localizedStringForKey("ADDPASS_PHONE_INSTRUCTIONS", "You must verify your phone number before you can purchase a pass.");
        if( firstAttemptedFeature.key == "UsePass" ) instructions = locManager.localizedStringForKey("USEPASS_PHONE_INSTRUCTIONS", "You must verify your phone number before you can use a pass.");
        if( instructions != locManager.localizedStringForKey("PHONE_INSTRUCTIONS", "Please verify your phone number below.")) break;
      }
    }

    return (
      <View style={[styles.container, {backgroundColor: generalColor}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }

        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this} style={{backgroundColor:generalColor}}>
          <ReUpText appManager={appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
          {
            isInputtingPhone ?
              instructions
            :
              locManager.localizedStringForKeyAndParams("INPUT_CODE_STATEMENT", [thisThing.getPhoneNumber()], "We have texted a code to %0%. Please input that code below.")
          }
          </ReUpText>
          <ShadowView layout={this.state.layout} appManager={appManager}/>
          {
            isInputtingPhone ?
              <View style={{alignSelf:'stretch', flexDirection:'column'}}>
                <View style={{paddingRight:8, alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
                  <ReUpText appManager={appManager} style={{marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[0]}</ReUpText>
                  <ReUpField
                    appManager={appManager}
                    ref={(a)=>{thisThing._phone1=a}}
                    key="phone1"
                    keyboardType={"phone-pad"}
                    onKeyPress={(event)=>
                    {
                      if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone1")
                    }}
                    onChangeText={(text) =>
                    {
                      thisThing._phoneText1 = text;
                      var hasValidPhone = thisThing.hasValidPhone();
                      if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
                      if( text.length >= 3 ) thisThing._phone2.focus()
                      thisThing.setIsInError(false);
                    }}
                    placeholder={thisThing._phoneText1Placeholder}
                    maxLength={3}
                    isInError={this.state.isInError}
                    style={{flex:-1, width:45}}/>
                  <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[1]}</ReUpText>
                  <ReUpField
                    appManager={appManager}
                    ref={(a)=>{thisThing._phone2=a}}
                    key="phone2"
                    keyboardType={"phone-pad"}
                    onKeyPress={(event)=>
                    {
                      if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone2")
                    }}
                    onChangeText={(text) =>
                    {
                      thisThing._phoneText2 = text;
                      var hasValidPhone = thisThing.hasValidPhone();
                      if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
                      if( text.length >= 3 ) thisThing._phone3.focus()
                      thisThing.setIsInError(false);
                    }}
                    placeholder={thisThing._phoneText2Placeholder}
                    maxLength={3}
                    isInError={this.state.isInError}
                    style={{flex:-1, width:45}}/>
                  <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[2]}</ReUpText>
                  <ReUpField
                    appManager={appManager}
                    ref={(a)=>{thisThing._phone3=a}}
                    key="phone3"
                    keyboardType={"phone-pad"}
                    onKeyPress={(event)=>
                    {
                      if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone3")
                    }}
                    onChangeText={(text) =>
                    {
                      thisThing._phoneText3 = text;
                      var hasValidPhone = thisThing.hasValidPhone();
                      if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
                      thisThing.setIsInError(false);
                    }}
                    placeholder={thisThing._phoneText3Placeholder}
                    maxLength={4}
                    isInError={this.state.isInError}
                    style={{flex:-1,width:65}}/>
                </View>
                {
                  this.state.errorMessage != null ?
                    <View>
                      <ReUpText appManager={appManager} style={{color:'red', alignSelf:'center', margin:10}}>
                      {this.state.errorMessage}
                      </ReUpText>
                    </View>
                  : null
                }

                {
                  this.state.hasValidPhone && this.state.errorMessage == null ?
                    <View style={{padding:20}}>
                      <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("TEXT_CODE_BUTTON", "Text My Code")} onPress={()=>
                        {
                          thisThing.sendCode();
                        }}/>
                    </View>
                  : null
                }
              </View>
            :
              <View style={{alignSelf:'stretch'}}>
                <View style={{flexDirection:'row', justifyContent:'center'}}>
                  <ReUpField
                    appManager={appManager}
                    ref={(a)=>{thisThing._code1=a}}
                    key={"code1"+thisThing.state.code1Date}
                    keyboardType={"phone-pad"}
                    onKeyPress={(event)=>
                    {
                      if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("code1")
                    }}
                    onChangeText={(text) =>
                    {
                      thisThing._codeText1 = text;
                      var hasValidCode = thisThing.hasValidCode();
                      if( thisThing.state.hasValidCode != hasValidCode ) thisThing.setState({hasValidCode});
                      if( text.length >= 1 ) thisThing._code2.focus()
                      thisThing.setIsInError(false);
                      if( hasValidCode && !this._hasAutoCheckedCode ) thisThing.checkCode();
                    }}
                    maxLength={1}
                    isInError={this.state.isInError}
                    style={{flex:-1,width:20, margin:10}}/>
                  <ReUpField
                    appManager={appManager}
                    ref={(a)=>{thisThing._code2=a}}
                    key="code2"
                    keyboardType={"phone-pad"}
                    onKeyPress={(event)=>
                    {
                      if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("code2")
                    }}
                    onChangeText={(text) =>
                    {
                      thisThing._codeText2 = text;
                      var hasValidCode = thisThing.hasValidCode();
                      if( thisThing.state.hasValidCode != hasValidCode ) thisThing.setState({hasValidCode});
                      if( text.length >= 1 ) thisThing._code3.focus()
                      thisThing.setIsInError(false);
                      if( hasValidCode && !this._hasAutoCheckedCode ) thisThing.checkCode();
                    }}
                    maxLength={1}
                    isInError={this.state.isInError}
                    style={{flex:-1,width:20, margin:10}}/>
                  <ReUpField
                    appManager={appManager}
                    ref={(a)=>{thisThing._code3=a}}
                    key="code3"
                    keyboardType={"phone-pad"}
                    onKeyPress={(event)=>
                    {
                      if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("code3")
                    }}
                    onChangeText={(text) =>
                    {
                      thisThing._codeText3 = text;
                      var hasValidCode = thisThing.hasValidCode();
                      if( thisThing.state.hasValidCode != hasValidCode ) thisThing.setState({hasValidCode});
                      if( text.length >= 1 ) thisThing._code4.focus()
                      thisThing.setIsInError(false);
                      if( hasValidCode && !this._hasAutoCheckedCode ) thisThing.checkCode();
                    }}
                    maxLength={1}
                    isInError={this.state.isInError}
                    style={{flex:-1,width:20, margin:10}}/>
                  <ReUpField
                    appManager={appManager}
                    ref={(a)=>{thisThing._code4=a}}
                    key="code4"
                    keyboardType={"phone-pad"}
                    onKeyPress={(event)=>
                    {
                      if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("code4")
                    }}
                    onChangeText={(text) =>
                    {
                      thisThing._codeText4 = text;
                      var hasValidCode = thisThing.hasValidCode();
                      if( thisThing.state.hasValidCode != hasValidCode ) thisThing.setState({hasValidCode});
                      if( text.length >= 1 ) thisThing._code5.focus()
                      thisThing.setIsInError(false);
                      if( hasValidCode && !this._hasAutoCheckedCode ) thisThing.checkCode();
                    }}
                    maxLength={1}
                    isInError={this.state.isInError}
                    style={{flex:-1,width:20, margin:10}}/>
                  <ReUpField
                    appManager={appManager}
                    ref={(a)=>{thisThing._code5=a}}
                    key="code5"
                    keyboardType={"phone-pad"}
                    onKeyPress={(event)=>
                    {
                      if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("code5")
                    }}
                    onChangeText={(text) =>
                    {
                      thisThing._codeText5 = text;
                      var hasValidCode = thisThing.hasValidCode();
                      if( thisThing.state.hasValidCode != hasValidCode ) thisThing.setState({hasValidCode});
                      if( text.length >= 1 ) thisThing._code6.focus()
                      thisThing.setIsInError(false);
                      if( hasValidCode && !this._hasAutoCheckedCode ) thisThing.checkCode();
                    }}
                    maxLength={1}
                    isInError={this.state.isInError}
                    style={{flex:-1,width:20, margin:10}}/>
                  <ReUpField
                    appManager={appManager}
                    ref={(a)=>{thisThing._code6=a}}
                    key="code6"
                    keyboardType={"phone-pad"}
                    onKeyPress={(event)=>
                    {
                      if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("code6")
                    }}
                    onChangeText={(text) =>
                    {
                      thisThing._codeText6 = text;
                      var hasValidCode = thisThing.hasValidCode();
                      if( thisThing.state.hasValidCode != hasValidCode ) thisThing.setState({hasValidCode});
                      if( hasValidCode && !this._hasAutoCheckedCode ) thisThing.checkCode();
                      thisThing.setIsInError(false);
                    }}
                    maxLength={1}
                    isInError={this.state.isInError}
                    style={{flex:-1,width:20, margin:10}}/>
                </View>
                {
                  this.state.errorMessage != null ?
                    <View>
                      <ReUpText appManager={appManager} style={{color:'red', alignSelf:'center', margin:10}}>
                      {this.state.errorMessage}
                      </ReUpText>
                    </View>
                  : null
                }
                {
                  this.state.hasValidCode && this.state.errorMessage == null ?
                    <View style={{padding:20}}>
                      <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("SUBMIT_CODE_BUTTON", "Submit Code")} onPress={()=>
                        {
                          thisThing.checkCode()
                        }}/>
                    </View>
                  : null
                }
              </View>
          }
        </ReUpScrollView>
        {
          this.state.shouldShowSpinner ?
          <ProgressOverlay ref={(c) => { this._ref_spinner = c; }} key="spinner" isVisible={this.state.shouldShowSpinner}
            layout={this.state.layout} appManager={appManager}>
          </ProgressOverlay>
          : null
        }
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },


  // meter

  meterContainer: {
    margin:10,
    height:20,
    borderRadius:10,
    flexDirection:'row',
  },
  meterFiller: {
    margin:1,
    height:18,
    borderRadius:9,
  },
  meterAntiFiller: {
    height:18,
    borderRadius:9,
  },

  // body

  bodyText: {
    margin:10,
    textAlign:'left',
  },

  alertTitle: {
    margin:4,
    textAlign:'center',
  },

  // choices

  choicesContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:10,
    marginLeft:0,
    marginRight:0,
    height:60,
    alignItems:'center',
    justifyContent:'center'
  },
  choiceButton: {
    justifyContent:'center',
    flex:1,
    height:40,
  },

  // credit card
  oldCardContainer: {
    flexDirection:'row',
    flex:1,
    alignItems:'center',
    height:60,
    paddingLeft:10,
    alignSelf:'center',
    paddingRight:10,
    justifyContent:'center',
  },
  creditCardIcon: {
    width: 50,
    justifyContent: 'center',
    textAlign: 'center',
    margin:4,
    opacity:.6,
  },
  creditCardText: {
    fontStyle:'italic',
    margin:4,
    flex:1,
    textAlign:'center',
    opacity:.6,
  },
  creditCardEditButton: {
    padding:4,
  },
  creditCardEditButtonIcon: {
    fontSize:30,
    backgroundColor:'transparent'
  },

  // new card
  cardNumberContainer: {
    flexDirection: 'row',
    margin:8,
    marginTop:0
  },

  textField: {
    width:-1
  },

  dateContainer: {
    flexDirection: 'row',
    marginHorizontal:8,
  },
  dateField: {
    flex:-1,
    width:40,
    textAlign:'center',
  },
  cvvField: {
    flex:-1,
    width:80,
    textAlign:'center',
  },
  dateSlash: {
    paddingLeft:8,
    paddingRight:8,
    alignSelf:'flex-end',
    textAlign:'center',
  },

  doneButton: {
    justifyContent:'center',
    flex:1,
  },

  segmentContainer: {
    height:50,
    flex:1,
    alignSelf:'center'
  },
});

// PhoneNumberVerify.getCards = function(featureData, appActions, data)
// {
//   var appManager = appActions._appManager;
//   var locManager = appManager.getLocalizationManager();
//   var isLoggedIn = appManager.isLoggedIn();
//   if( !isLoggedIn ) return [];
//   if( typeof appManager.getFeatureForName("AddCredit") === 'undefined' ) return [];
//
//   var user = appManager.currentUser();
//   var paymentInfo = appManager.getPaymentInfo();
//   if( !(typeof paymentInfo === 'undefined' || paymentInfo.length <= 0) ) return [];
//
//   var iconName = featureData.data.icon.replace("fa-", "")
//
//   return [{
//     didSelect : function() {appActions.requestFeatureName("PhoneNumberVerify")},
//     title : featureData.data.title,
//     body1 : locManager.localizedStringForKey("PAYMENT_TYPE_TIP"),
//     icon : featureData.data.icon.replace("fa-", ""),
//     cardType : 0,
//     sortOrder : 5
//   }]
// }


PhoneNumberVerify.dataDependencies = ["Users"];

module.exports = PhoneNumberVerify;
